<template>
<div class="modal fade" id="chooseHomeworkDeadlineModalForm" tabindex="-1" aria-labelledby="chooseHomeworkDeadlineModalFormLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="chooseHomeworkDeadlineModalFormLabel">Choose homework and deadline</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div v-if="loading" class="text-center my-4">
                    <div class="spinner-border" role="status">
                        <span class="sr-only">&nbsp;&nbsp;Loading...</span>
                    </div>
                </div>
                <div v-else>
                    <form @submit.prevent="submitForm">
                    <div class="mb-3">
                        <label for="homework_id" class="form-label">Choose Homework</label>
                        <select class="form-control" id="homework_id" v-model="localHomework.id" @change="fetchHomeworkWithSubtasks" required>
                        <option v-for="homework in homeworks" :key="homework.id" :value="homework.id">{{ homework.title }}</option>
                        </select>
                    </div>
                    <div v-if="localHomework.id"> 
                        <div class="mb-3">
                            <label for="deadline_id" class="form-label">Choose Deadline</label>
                            <select class="form-control" id="deadline_id" v-model="selectedDeadline" :disabled="manualEvaluation" required>
                                <option v-for="deadline in deadlines" :key="deadline.id" :value="deadline.id">{{ formatDate(deadline.date) }} - {{ getEvaluationTypeLabel(deadline.evaluation_type) }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        <button type="submit" class="btn btn-primary" data-bs-dismiss="modal" :disabled="!localHomework.id || !selectedDeadline">Submit</button>
                    </div> 
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

<StemErrorModal ref="stemErrorModal" />
</template>

<script>
import HomeworkController from '@/controllers/HomeworkController';
import StemErrorModal from './StemErrorModal.vue';
import Deadline from '@/models/deadline';

export default {
    name: 'chooseHomeworkDeadlineModalForm',
    components: {
        StemErrorModal
    },
    data() {
        return {
            loading: true,
            selectedDeadline: null,
            localHomework: { ...this.homework },
            homeworks: [],
            deadlines: [],
        };
    },
    async created() {
        try {
            this.homeworks = await HomeworkController.fetchHomeworks();
        } catch (error) {
            this.$refs.stemErrorModal.showError('Error', error.message);
        } finally {
            this.loading = false;
        }
    },
    mounted() {
        // Reset = delete all data from the form
        const modalElement = document.getElementById('chooseHomeworkDeadlineModalForm');
        modalElement.addEventListener('hidden.bs.modal', this.resetForm);
    },
    methods: {
        resetForm() {
            this.localHomework = { ...this.homework };
            this.deadlines = [];
            this.selectedDeadline = null;
        },
        formatDate(datetime) {
            return Deadline.formatDateTime(datetime);
        },
        getEvaluationTypeLabel(type) {
            return Deadline.getEvaluationTypeLabel(type);
        },
        async fetchHomeworkWithSubtasks() {
            this.loading = true;
            if (this.localHomework.id) {
                try {
                    const homeworkWithRelatedData = await HomeworkController.fetchHomeworkByIdWithRelatedData(this.localHomework.id);
                    // Sorting deadlines
                    this.deadlines = Deadline.sortDeadlinesByDate(homeworkWithRelatedData.deadlines);
                } catch (error) {
                    this.$refs.stemErrorModal.showError('Error', error.message);
                } finally {
                    this.loading = false;
                }
            } else {
                this.loading = false;
            }
        },
        async submitForm() {
            this.$emit('submitForm', this.selectedDeadline);
        }
    },
}
</script>